/** Tooltip copy for Settings page labels — presentation only. */
export const SETTINGS_FIELD_HELP = {
  selfEnrollment: 'When on, learners can enroll in published courses without a personal invite link.',
  certificates: 'Automatically generates a branded PDF certificate when a learner passes a course.',
  twoFactor: 'Requires a second verification step at sign-in for added account security.',
  emailNotifications: 'Sends alerts for learner submissions, weekly digests, and course reminders.',
  viewAsStudent: 'Preview your workspace as an enrolled learner to see what they experience.',
  usageCourses: 'Published courses on your plan. The bar shows how much of your course limit is used.',
  usageAssessments: 'Tests and quizzes created across your workspace. The bar shows plan limit usage.',
  usageStudents: 'Unique learners enrolled in your courses. The bar shows plan limit usage.',
  accountNumber: 'Bank account number where Stripe sends your course purchase payouts.',
  routingNumber: 'Bank routing number used for ACH payout transfers from Stripe.',
  catalogSearchEmail: 'Find another instructor by email to import their courses into the shared catalog.',
};

/** Tooltip copy for System settings (split payment) — presentation only. */
export const SYSTEM_SETTINGS_FIELD_HELP = {
  role: 'Admin role that receives the configured split payment fee from learner purchases.',
  percentage: 'Share of each in-app purchase allocated to this role, from 0 to 100.',
  splitPaymentFee: 'Platform fee taken from instructor revenue on in-app course and assessment purchases.',
  variable: 'Internal configuration key — identifies this row as the split payment setting.',
  value: 'Current split payment percentage applied to qualifying purchases.',
  status: 'Whether this split payment configuration is active.',
};

/** Tooltip copy for list table column headers — presentation only. */
export const LIST_TABLE_FIELD_HELP = {
  assessmentStatus: 'Enabled assessments are available to learners; disabled assessments are hidden regardless of schedule.',
  questionType: 'Question format — for example multiple choice, text, or image-based.',
  questionCategory: 'How the question is built — Direct, Scenario, Passage, or Image.',
  questionStatus: 'Active questions appear in the assessment; disabled questions are excluded from attempts.',
};
